import React from "react";
import Chip from "@mui/material/Chip";

const toneConfig = {
  neutral: {
    bg: "var(--ec-status-neutral-bg)",
    text: "var(--ec-status-neutral-text)",
    border: "var(--ec-status-neutral-border)",
    fill: "var(--ec-status-neutral-text)",
  },
  info: {
    bg: "var(--ec-status-info-bg)",
    text: "var(--ec-status-info-text)",
    border: "var(--ec-status-info-border)",
    fill: "var(--ec-status-info-text)",
  },
  success: {
    bg: "var(--ec-status-success-bg)",
    text: "var(--ec-status-success-text)",
    border: "var(--ec-status-success-border)",
    fill: "var(--ec-status-success-text)",
  },
  warning: {
    bg: "var(--ec-status-warning-bg)",
    text: "var(--ec-status-warning-text)",
    border: "var(--ec-status-warning-border)",
    fill: "var(--ec-status-warning-text)",
  },
  error: {
    bg: "var(--ec-status-error-bg)",
    text: "var(--ec-status-error-text)",
    border: "var(--ec-status-error-border)",
    fill: "var(--ec-status-error-text)",
  },
  accent: {
    bg: "var(--ec-color-primary-soft)",
    text: "var(--ec-color-primary-dark)",
    border: "var(--ec-color-primary-border-soft)",
    fill: "var(--ec-color-primary)",
  },
};

const UIStatusChip = ({
  tone = "neutral",
  selected = false,
  size = "small",
  sx,
  ...props
}) => {
  const config = toneConfig[tone] || toneConfig.neutral;

  return (
    <Chip
      size={size}
      {...props}
      sx={{
        height: size === "small" ? 24 : undefined,
        borderRadius: "999px",
        fontWeight: 600,
        fontSize: "0.72rem",
        backgroundColor: selected ? config.fill : config.bg,
        color: selected ? "#fff" : config.text,
        border: `1px solid ${selected ? "transparent" : config.border}`,
        transition: "all 0.15s ease",
        "& .MuiChip-label": {
          px: size === "small" ? "8px" : undefined,
        },
        "& .MuiChip-deleteIcon": {
          color: selected ? "#fff" : config.text,
          opacity: 0.72,
          "&:hover": {
            color: selected ? "#fff" : config.text,
            opacity: 1,
          },
        },
        ...sx,
      }}
    />
  );
};

export default UIStatusChip;
